module.exports = __webpack_public_path__ + "media/images/abagail-1-e475248b8858749464c86b0f5f76af5c.png";